import { Component, inject, Input } from '@angular/core';
import { SuggestedQuestionService } from '../../services/suggested-question-service';

@Component({
  selector: 'aiops-suggestion-chip',
  imports: [],
  templateUrl: './suggestion-chip.html',
})
export class SuggestionChip {
  @Input({ required: true })
  wording: string = '';

  suggestedQuestionService = inject(SuggestedQuestionService);

  suggested() {
    this.suggestedQuestionService.updateSuggestion({ text: this.wording, autoSend: true });
  }
}
